export default {
  canCreate: (state, getters) => (model) => {
    return getters.hasPermission(model, 'create')
  },
  canEdit: (state, getters) => (model) => {
    return getters.hasPermission(model, 'update')
  },
  canDelete: (state, getters) => (model) => {
    return getters.hasPermission(model, 'destroy')
  },
  canView: (state, getters) => (model) => {
    return getters.hasPermission(model, 'read')
  },
  canViewAll: (state, getters) => (model) => {
    return getters.hasPermission(model, 'readAll')
  },
  hasPermission: (state) => (model, action) => {
    return (state.permissions[model] && state.permissions[model][action])
  },
  isIntegrator: (state) => {
    return state.loggedIn.isIntegrator
  },
  allOrganizations: (state) => {
  },
  canEditAllOrganizations: (state) => {
    return state.loggedIn.allOrganizations
  },
  getName: (state) => {
    const user = state.current
    if (user.firstName && user.lastName) {
      return `${user.firstName} ${user.lastName}`
    } else {
      return user.email
    }
  }
}
